import layoutHeaderAside from '@/layout/header-aside'
import decision from "@/router/modules/decision";

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
let _import

if (process.env.NODE_ENV === 'production'){
    _import = require('@/libs/util.import.production')
}else{
    _import = require('@/libs/util.import.development')
}


import roadProduction from './modules/roadProduction'
import structure from './modules/structure'
import system from './modules/system'
import systemApp from './modules/systemApp'
import specialMaintenance from './modules/specialMaintenance'
import fileManagement from './modules/fileManagement'
import appendant from './modules/appendant'
import device from './modules/device'
import storage from './modules/storage'
import auxiliary from './modules/auxiliary'
import workFlow from './modules/workFlow'
import everyday from './modules/everyday'
import qualitative from './modules/qualitative'
import emergencyRescue from './modules/emergencyRescue'
import statistics from './modules/statistics'
import personal from './modules/personal'
import mqi from './modules/mqi'
import maintenanceUnit from './modules/maintenanceUnit'
import measurementAndPayment from './modules/measurementAndPayment'
import disasterWaterDamage from './modules/disasterWaterDamage'
import bTCChecks from './modules/bTCChecks'
import trafficData from './modules/trafficData'
import roadNetworkRemould from './modules/roadNetworkRemould'
import decisionBase from './modules/decisionBase'
import bridgeMaintenanceDecision from "./modules/bridgeMaintenanceDecision";
import localPage from "./modules/localPage"
import macroDecisionMaking from './modules/macroDecisionMaking'
import culvertDecision from  './modules/culvertDecision'
import sideSlopeDecision from "@/router/modules/sideSlopeDecision";
import wtlrouter from "@/router/modules/wtlrouter";
import qmxrouter from "@/router/modules/qmxrouter";
import GANSHUExcel from "./modules/GANSHUExcel";
import yjjcopy from "@/router/modules/yjjcopy"
import labor from "@/router/modules/labor"
/**
 * 在主框架内显示
 */
const frameIn = [{
    path: '/',
    redirect: { name: 'system' },
    component: layoutHeaderAside,
    children: [
        // 演示页面
        {
            path: 'page1',
            name: 'page1',
            meta: {
                title: '演示页面1',
                auth: true
            },
            // im (@/views/demo/page1)
            component: _import('demo/page1')
        },
        {
            path: 'page2',
            name: 'page2',
            meta: {
                title: '演示页面2',
                auth: true,
                cache: true
            },
            component: _import('demo/page2')
        },
        {
            path: 'page3',
            name: 'page3',
            meta: {
                title: 'treeTable',
                auth: true
            },
            component: _import('demo/page3')
        },
        {
            path: 'page4',
            name: 'page4',
            meta: {
                title: '我是测试页面',
                auth: true
            },
            component: _import('demo/page4/page4')
        },
        // 首页
        {
            path: '/index',
            name: 'index',
            meta: {
                title: '首页',
                auth: true
            },
            component: _import('system/index')
        },
        //基础路产页面
        ...roadProduction,
        //养护单位管理
        ...maintenanceUnit,
        //交安设施
        ...appendant,
        //机械设备
        ...device,
        //辅助资产
        ...auxiliary,
        //养护材料
        ...storage,
        //构造物
        ...structure,
        //维修专项管理
        ...specialMaintenance,
        //电子档案管理
        ...fileManagement,
        //日常养护_定量养护
        ...workFlow,
        //日常养护_普通干线养护
        ...everyday,
        //日常养护_定性养护
        ...qualitative,
        //日常管理_维修档案
        ...yjjcopy,
        //应急抢险管理
        ...emergencyRescue,
        //桥隧涵检查数据
        ...bTCChecks,
        //系统角色管理
        ...system,
        //app后台管理
        ...systemApp,
        //echarts报表
        ...statistics,
        //人事
        ...personal,
        //路网改造
        ...roadNetworkRemould,
        //路况评定
        ...mqi,
        //计量支付
        ...measurementAndPayment,
        //灾害水毁
        ...disasterWaterDamage,
        //养护决策
        ...decisionBase,
        //交通量
        ...trafficData,
        //策略
        ...decision,
        //桥梁养护决策
        ...bridgeMaintenanceDecision,
        //宏观决策
        ...macroDecisionMaking,
        //测试路由
        ...localPage,
        //涵洞决策
        ...culvertDecision,
        //边坡决策
        ...sideSlopeDecision,
        //王韬略
        ...wtlrouter,
		//陈鑫
		...qmxrouter,
        // 系统 前端日志
        ...GANSHUExcel,
        {
            path: 'log',
            name: 'log',
            meta: {
                title: '前端日志',
                auth: true
            },
            component: _import('system/log')
        },
        // 刷新页面 必须保留
        {
            path: 'refresh',
            name: 'refresh',
            hidden: true,
            component: _import('system/function/refresh')
        },
        // 页面重定向 必须保留
        {
            path: 'redirect/:route*',
            name: 'redirect',
            hidden: true,
            component: _import('system/function/redirect')
        },
        // 劳务管理
        ...labor

    ]
}]

/**
 * 在主框架之外显示
 */
const frameOut = [

    // 登录
    {
        path: '/login',
        name: 'login',
        component: _import('system/login')
    },
    {
        path: '/system',
        name: 'system',
        meta: {
            title: '甘肃公路互联网+道路养护平台',
            auth: true
        },
        component: _import('system/controllers/system')
    },
    {
        path: '/gisMap',
        name: 'gisMap',
        meta: {
            title: '全省公路系统综合监管平台',
            auth: true
        },
        component: () =>
            import ('@/views/system/map/gisMap')
    },
    {
        path: '/mqiLocal',
        name: 'mqiLocal',
        meta: {
            title: '路况评定',
            auth: true
        },
        component: () =>
            import ('@/views/system/mqi/mqiLocal')
    },
    {
        path: '/decisionLocal',
        name: 'decisionLocal',
        meta: {
            title: '健康监测',
            auth: true
        },
        component: () =>
            import ('@/views/system/mqi/decisionLocal')
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        meta: {
            title: '数据中心',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/Demo/indexggg')
    },
    {
        path: '/indexggg',
        name: 'indexggg',
        meta: {
            title: '数据中心',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/Demo/indexggg')
    },
    {
        path: '/generate',
        name: 'generate',
        meta: {
            title: '生成界面',
            auth: true
        },
        component: () =>
            import ('@/views/Generate')
    },
    {
        path: '/lmSdYxJC_lm',
        name: 'lmSdYxJC_lm',
        meta: {
            title: '路面监测',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/lmSdYxJC/lm')
    },
    {
        path: '/lmSdYxJC_sd',
        name: 'lmSdYxJC_sd',
        meta: {
            title: '隧道监测',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/lmSdYxJC/sd')
    },
    {
        path: '/lmSdYxJC_yx',
        name: 'lmSdYxJC_yx',
        meta: {
            title: '沿线设施监测',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/lmSdYxJC/yx')
    },
    {
        path: '/bridgeMonitoring',
        name: 'bridgeMonitoring',
        meta: {
            title: '桥梁监测',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/lmSdYxJC/bridgeMonitoring')
    },
    {
        path: '/slopeMonitoring',
        name: 'slopeMonitoring',
        meta: {
            title: '边坡监测',
            auth: true
        },
        component: () =>
            import ('@/views/system/controllers/lmSdYxJC/slopeMonitoring')
    }
]

/**
 * 错误页面
 */
const errorPage = [{
    path: '*',
    name: '404',
    component: _import('system/error/404')
}]

// 导出需要显示菜单的
export const frameInRoutes = frameIn

// 重新组织后导出
export default [
    ...frameIn,
    ...frameOut,
    ...errorPage
]
